<template>
    <div class="container">
        <div v-if="checkingToken" class="col-lg-4 col-md-6 ml-auto mr-auto">
            <card>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                 spin></font-awesome-icon></span></h1>
            </card>
        </div>
        <div v-if="checkingToken === false" class="col-lg-4 col-md-6 ml-auto mr-auto">
            <form>
                <card v-if="invalidtoken === false" class="card-login card-white">
                    <template slot="header">
                        <img src="img/card-primary.png" alt=""/>
                        <h1 class="card-title">New Password</h1>
                    </template>
                    <div>
                        <base-input
                                v-model="password"
                                v-validate="'required'"
                                :error="getError('password')"
                                name="password"
                                type="password"
                                ref="password"
                                placeholder="Password"
                                addon-left-icon="lock"
                        >
                        </base-input>
                        <base-input
                                v-model="password_confirmation"
                                v-validate="'required|confirmed:password'"
                                :error="getError('password_confirmation')"
                                name="password_confirmation"
                                type="password"
                                placeholder="Password confirmation"
                                addon-left-icon="lock"
                        >
                        </base-input>
                        <p class="text-danger" v-if="error">
                            <strong>Error!</strong> Please check your password!
                        </p>
                    </div>


                    <div slot="footer">
                        <base-button type="primary" v-if="!success" :loading="loading" v-on:click="validate"
                                     class="mb-3" size="lg"
                                     block>
                            <span>Set new password</span>
                        </base-button>
                        <p class="text-primary" v-if="success">Password has been reset! You'll be redirected to the
                            login page shortly!</p>
                    </div>
                </card>
                <card v-if="invalidtoken " class="card-login card-white">

                    <p class="text-danger">
                        The token for your password reset was invalid!
                    </p>

                    <p class="text-info">
                        Please request a new password reset token <a href="/forgot">here</a>
                    </p>
                </card>
            </form>
        </div>
    </div>
</template>
<script>

    export default {
        components: {},
        data() {
            return {
                password: '',
                password_confirmation: '',
                error: false,
                loading: false,
                success: false,
                invalidtoken: false,
                checkingToken: false,
            };
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                this.error = false;
                this.success = false;
                this.$validator.validateAll().then(isValid => {
                    this.loading = true;
                    this.reset();
                });
            },
            checkIfTokenValid() {
                this.checkingToken = true;
                let token = this.$route.params.token;
                this.$store.dispatch('AUTH_CHECK_TOKEN', {token}).then((resp) => {
                }).catch(error => {
                    this.invalidtoken = true;
                    this.checkingToken = false;

                }).finally(() => {
                    this.checkingToken = false;
                })
            },
            reset() {
                let password = this.password;
                let token = this.$route.params.token;
                this.$store.dispatch('AUTH_PASS_RESET', {password, token}).then((resp) => {
                    this.success = true;
                    setTimeout(() => this.$router.push('/login'), 2000);
                }).catch(error => {
                    this.error = true;
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        mounted() {
            console.log('mounted');
            this.checkIfTokenValid();
        }
    };
</script>
<style>
    .navbar-nav .nav-item p {
        line-height: inherit;
        margin-left: 5px;
    }
</style>
